import React from "react";
import Navbar from "../components/navbar/Navbar";
import RollAgenda from "../components/roll-agenda/RollAgenda";

function RollAgendaScreen() {
  return (
    <div className="container-fluid bg-theme" style={{ height: "100vh" }}>
      <div className="row h-100">
        <div className="d-flex flex-column align-items-center justify-content-start">
          <div className="w-100 mb-2">
            <Navbar />
          </div>
          <RollAgenda />
        </div>
      </div>
    </div>
  );
}

export default RollAgendaScreen;